import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { http } from '@/lib/http';
import type { SubCase } from './types';

async function fetchSubCases(caseUrn: string): Promise<SubCase[]> {
  return http.get(`v1/cases/${encodeURIComponent(caseUrn)}/sub-cases`).json<SubCase[]>();
}

// Per-case sub-case list. The PassengersTab + the lock-indicator rail
// both subscribe — short staleTime so newly-opened sub-cases (from
// airline manifest fan-out) appear without a hard refresh.
export function useSubCasesForCase(caseUrn: string): UseQueryResult<SubCase[]> {
  return useQuery({
    queryKey: ['cases', caseUrn, 'sub-cases'],
    queryFn: () => fetchSubCases(caseUrn),
    staleTime: 10_000,
    refetchOnWindowFocus: true,
  });
}
